Vue.component("variant-content", {
  data: () => {
    return {
      productId: "",
      productData: {},
      optionList: [],
      freeShipTab: true,
      showVariantSelect: false,
      option1: "",
      variantIndex: 0,
      freeStr: "Free",
      areaUrl: "api/v1/area/list",
      deliveryUrl: "api/v1/area/ageing",
      btnDisabled: false,
      wishStr: "wishList",
      freeShipTipEle: "",
      showMore: false,
      productRightHeight: 0,
      areaList: [],
      showAreaList: false,
      areaFilterText: "", // 新增：用于过滤区域列表的文本
      filteredAreaList: [], // 新增：过滤后的区域列表
      deliveryList: [], // 新增：用于存储配送信息
      deliverySwiper: null,
      selectArea: {},
      showViewImage: false,
      viewImageSrc: "",
      addCartTips: "Please add the products",
    };
  },
  async created() {
    this.productId = document.querySelector("#variant-content")?.dataset.id;
    this.freeShipTipEle = document.querySelector(".product-right .free-ship");
    await this.getAreaList();
    const jsonString = theme.getCookies("userLocation");
    const current_data = theme.inspectJson(jsonString);
    if (current_data?.iso) {
      this.selectArea = this.areaList.find(
        (item) => item.iso2_code == current_data.iso.toUpperCase()
      );
    } else {
      this.selectArea = this.areaList.find((item) => item.iso2_code == "US");
    }
    this.getDeliveryInfo(this.selectArea?.iso2_code);
    await this.getData();
    await this.handleDataKey();
    if (this.showFreeShipFlag) {
      this.filterFreeShip();
    } else {
      this.freeShipTab = false;
      if (this.productData.options) {
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue;
        this.option1 = this.optionList[0]?.value;
      }
    }
    this.$nextTick(() => {
      this.addBorderNoneClass();
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.checkSticky, true);
    // 添加点击事件监听器，用于检测点击区域外的元素
    document.addEventListener("click", this.handleClickOutside);
    this.$nextTick(() => {
      this.checkSticky();

      this.deliverySwiper = new Swiper(".swiper-container-delivery", {
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        uniqueNavElements: true,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      });
    });
  },
  updated() {
    this.$nextTick(() => {
      this.checkSticky();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("resize", this.checkSticky, true);
    // 添加点击事件监听器，用于检测点击区域外的元素
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    // 显示免邮tab
    showFreeShipFlag() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return false;
      for (let item of this.productData.variants) {
        if (item.title.indexOf(this.freeStr) !== -1) {
          return true;
        }
      }
      return false;
    },
    totalItem() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return 0;
      let total = 0;
      for (let item of this.productData.variants) {
        total += parseInt(item.quantity);
      }
      return total;
    },
    totalPrice() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return 0;
      let total = 0;
      for (let item of this.productData.variants) {
        const price = theme.convertCurrency(item.price, "usdToSet");
        const totalPrice = theme.multiply(parseInt(item.quantity), price);
        total = theme.add(total, totalPrice);
      }
      return total;
    },
    // 是否定制
    isCustom() {
      if (
        this.productData?.customizeText == true ||
        this.productData?.customizeImage == true
      ) {
        return true;
      }
      return false;
    },
    // 过滤后的区域列表
    filteredAreas() {
      if (!this.areaFilterText) {
        return this.areaList;
      }
      const searchText = this.areaFilterText.toLowerCase();
      return this.areaList.filter((item) => {
        const areaName = item.area_name.toLowerCase();
        const isoCode = item.iso2_code.toLowerCase();
        return areaName.includes(searchText) || isoCode.includes(searchText);
      });
    },
  },
  methods: {
    async getData() {
      const product = new ProductApi();
      const productData = await product.getProductData(this.productId);

      if (productData) {
        this.productData = productData;
        this.showVariantSelect = false;
        if (this.productData?.variants[0]?.selectedOptions.length == 2) {
          this.productData = this.handleData(productData);
          this.showVariantSelect = Object.values(
            this.productData?.options
          ).every((arr) => arr.length > 2);
        } else {
          const favorite = this.isFavorite();
          this.$set(this.productData, "favorite", favorite);
        }
        if (this.productData.minQuantity && this.productData.minQuantity > 1) {
          document.querySelector(
            ".wbpricetax .min-quantity .number"
          ).textContent = this.productData.minQuantity;
          document.querySelector(
            ".wbpricetax .min-quantity .unit"
          ).textContent = "pieces";
        }
      }
    },

    isFavorite() {
      var wishString = localStorage.getItem("wishList");
      var wishData = theme.inspectJson(wishString) || [];
      const favorite = wishData.includes(this.productData.id);
      return favorite;
    },

    handleData(originalData) {
      // 深拷贝原始数据
      const newData = { ...originalData };
      const selectedOptions = originalData?.variants[0]?.selectedOptions;
      // 构建新的 options 对象
      const options = {};
      for (let item of selectedOptions) {
        options[item.name] = [];
      }

      // 为每个 variant 添加 option1 和 option2
      const newVariants = originalData.variants.map((variant) => {
        const newOptions = {};
        let count = 0;
        for (let option in options) {
          ++count;
          const optionValue = variant.selectedOptions.find(
            (opt) => opt.name == option
          );
          newOptions[`options${count}`] = optionValue;
        }
        return {
          ...variant,
          ...newOptions,
        };
      });

      // 从 variants 中提取选项值和对应的图片
      originalData.variants.forEach((variant) => {
        variant.selectedOptions.forEach((option) => {
          const optionKey = option.name;
          // 检查该值是否已经存在
          const existingOption = options[optionKey].find(
            (item) => item.value === option.value
          );
          if (!existingOption) {
            options[optionKey].push({
              value: option.value,
              img: variant.featureImage, // 使用该 variant 的特征图片
              count: 0,
            });
          }
        });
      });

      const favorite = this.isFavorite();
      // 构建最终的数据结构
      return {
        ...newData,
        favorite,
        options,
        variants: newVariants,
      };
    },
    // 处理数据增加key
    async handleDataKey() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      for (let item of this.productData.variants) {
        let isFreeShip = false;
        if (this.showFreeShipFlag) {
          isFreeShip =
            (item.freeShipping && item.title.indexOf(this.freeStr) != -1) ??
            false;
        } else {
          isFreeShip = item.freeShipping;
        }

        this.$set(item, "quantity", 0);
      }
    },
    // 根据变体ID判断是否免邮
    async getVFreeShipping() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      const id = [];
      for (let item of this.productData.variants) {
        id.push(item.id);
      }
      const url = `${this.freeVUrl}`;
      const response = await fetchConnect(url, "POST", { id });
      if (!response.error) {
        return response.data.items;
      }
      return null;
    },

    // 处理图片地址
    handleImg(img, width) {
      if (!img) return "";
      if (img.indexOf("width=") == -1 && img.indexOf("?") == -1) {
        if (img.indexOf("?") != -1) {
          return `${img}&width=${width}`;
        }
        return `${img}?width=${width}`;
      }
      return img;
    },
    // 处理变体名称显示(去掉Free)
    handleVariantName(name) {
      if (!name) return "";
      if (name.indexOf(this.freeStr) != -1) {
        return name.split(this.freeStr)[1];
      }
      return name;
    },
    // 处理多变体时title显示（只显示最后一个）
    handleTitle(title) {
      if (!title) return "";
      if (title.indexOf(` / `)) {
        const arr = title.split(` / `);
        return arr[arr.length - 1];
      }
      return this.handleVariantName(title);
    },

    // 过滤免邮变体
    filterFreeShip() {
      this.freeShipTab = true;
      this.freeShipTipEle?.classList.remove("hidden");
      for (let item of this.productData.variants) {
        if (item.title.indexOf(this.freeStr) != -1) {
          this.$set(item, "freeTabFlag", true);
        } else {
          this.$set(item, "noFreeTabFlag", false);
        }
      }
      if (this.productData.options) {
        this.optionList = [];
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue.filter(
          (item) => item.value.indexOf(this.freeStr) != -1
        );
        this.option1 = this.optionList[0]?.value;
        this.variantIndex = 0;
      }
      this.$nextTick(() => {
        this.addBorderNoneClass();
      });
    },
    // 过滤非免邮变体
    filterNoFreeShip() {
      this.freeShipTab = false;
      this.freeShipTipEle?.classList.add("hidden");
      for (let item of this.productData.variants) {
        if (item.title.indexOf(this.freeStr) == -1) {
          this.$set(item, "noFreeTabFlag", true);
        } else {
          this.$set(item, "freeTabFlag", false);
        }
      }
      if (this.productData.options) {
        this.optionList = [];
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue.filter(
          (item) => item.value.indexOf(this.freeStr) == -1
        );
        this.option1 = this.optionList[0]?.value;
        this.variantIndex = 0;
      }
      this.$nextTick(() => {
        this.addBorderNoneClass();
      });
    },
    // 切换变体选项
    selectOption(option, index) {
      this.option1 = option.value;
      this.variantIndex = index;
      document.querySelector(".attr-name .text-active").innerText =
        this.handleVariantName(option.value);
      document.querySelector(".variants-list").scrollTop = 0;
      this.$nextTick(() => {
        this.addBorderNoneClass();
      });
    },
    // 变体列表数据是否显示
    filterVariantShow(variant) {
      // 双变体
      if (this.showVariantSelect) {
        const equal = variant?.options1?.value == this.option1;
        return (
          (!this.showFreeShipFlag ||
            variant.freeTabFlag ||
            variant.noFreeTabFlag) &&
          equal
        );
        // 其他
      } else {
        return (
          !this.showFreeShipFlag || variant.freeTabFlag || variant.noFreeTabFlag
        );
      }
    },
    // 更新选择的产品总数
    updateTotalCount() {
      for (let option of this.optionList) {
        let totalCount = 0;
        for (let item of this.productData.variants) {
          if (item.options1?.value == option.value) {
            totalCount += Number(item.quantity);
          }
        }
        option.count = totalCount;
      }
    },
    // 数量减少
    reduceQuantity(variant) {
      if (variant.quantity <= 0) return;
      const step = this.productData.minBatch || 1;

      // 按步长减少，确保不小于0
      const newQuantity = variant.quantity - step;
      variant.quantity = Math.max(0, newQuantity);
      this.updateTotalCount();
    },
    // 数量增加
    addQuantity(variant) {
      const step = this.productData.minBatch || 1;
      if (variant.quantity >= variant.inventoryQuantity) return;

      // 按步长增加，确保不超过库存
      const newQuantity = variant.quantity + step;
      variant.quantity = Math.min(variant.inventoryQuantity, newQuantity);
      this.updateTotalCount();
    },
    // 修改数量
    changeQuantity(variant) {
      const step = this.productData.minBatch || 1;
      let inputQuantity = parseInt(variant.quantity) || 0;

      if (inputQuantity <= 0) {
        variant.quantity = 0;
      } else {
        // 将输入的数量调整为最接近的步长倍数（向下取整）
        let adjustedQuantity = Math.floor(inputQuantity / step) * step;
        adjustedQuantity = adjustedQuantity == 0 ? step : adjustedQuantity;
        // 确保不超过库存限制
        variant.quantity = Math.min(
          adjustedQuantity,
          variant.inventoryQuantity
        );
      }
      this.updateTotalCount();
    },
    // 计算当前产品在购物车数据中的最小数量
    getMinQuantity() {
      let quantity = 0;
      if (cartPop) {
        cartPop.cartList.forEach((item) => {
          if (item.checked && item.product_id == this.productData.id) {
            quantity = theme.add(quantity, item.quantity);
          }
        });
      }
      return quantity;
    },
    // 加入购物车
    addToCart() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      const items = [];
      let totalQuantity = 0;
      const minQuantity = this.productData.minQuantity ?? 1;
      const minBatch = this.productData.minBatch ?? 1;
      for (let item of this.productData.variants) {
        if (item.quantity >= minBatch) {
          totalQuantity = theme.add(totalQuantity, item.quantity);
          items.push({
            quantity: item.quantity,
            id: item.id,
            variant_id: item.id,
            checked: true,
            url: this.productData.onlineStoreUrl,
            product_id: item.productId,
            product_title: this.productData.title,
            featured_image: { url: item.featureImage },
            variant_options: item.selectedOptions,
            final_price: item.price,
            weight: item.weight,
            min_batch: this.productData.minBatch,
            min_quantity: this.productData.minQuantity,
          });
        }
      }
      if (theme.add(totalQuantity, this.getMinQuantity()) < minQuantity) {
        if (minQuantity > 1)
          this.addCartTips = `Min. order: ${minQuantity} pieces`;
        this.btnDisabled = true;
        let timer = setTimeout(() => {
          this.btnDisabled = false;
          clearTimeout(timer);
        }, 1500);
      } else {
        this.btnDisabled = false;
      }
      if (!this.btnDisabled) {
        this.addToCartRequest(items);
      }
    },
    // 将变体数量重置
    resetQuantity() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      for (let item of this.productData.variants) {
        item.quantity = 0;
      }
      this.updateTotalCount();
    },
    // 加购请求
    async addToCartRequest(cartItems) {
      const message = document.getElementById("promptMessage"); //添加成功
      const adapter = new StorageAdapter();
      const shopify = new ShopifyRelatedV2();
      const localKey = "cartItems";
      const items = await adapter.create({
        key: localKey,
        value: cartItems,
      });
      if (items) {
        this.resetQuantity();
        message.classList.remove("hidden");
        message.classList.add("show");
        var timer = setTimeout(() => {
          clearTimeout(timer);
          message.classList.remove("show");
          message.classList.add("hidden");
        }, 2000);
        if (cartPop) {
          const list = [];
          items.forEach((item) => {
            const index = cartItems?.findIndex(
              (cartItem) => cartItem.variant_id == item.variant_id
            );
            if (index != -1) {
              list.push(item);
            }
          });
          cartPop.cartList = items;
          cartPop.showPop = true;
          const timer = setTimeout(() => {
            clearTimeout(timer);
            cartPop.showPop = false;
          }, 3000);
          cartPop.shopifyCartData = await shopify.create(items);
          theme.reportAddToCart(cartItems);
          cartPop.handleDataList();
        }
      }
    },
    // 收藏或取消收藏
    async updateWish() {
      const wishAdapter = new ProductAdapter();
      this.productData.favorite = !this.productData.favorite;
      if (this.productData.favorite) {
        await wishAdapter.addWish(this.productData);
      } else {
        await wishAdapter.cancelWish(this.productData);
      }
    },
    personalize() {
      var newWindow = window.open("", "_blank");
      // 判断新窗口是否成功打开
      if (newWindow) {
        // 在新打开的窗口中设置跳转的网址
        newWindow.location.href = window.whatsappUrl;
      }
    },
    // 设置悬浮样式
    checkSticky() {
      const productRight = document.querySelector(".product-right");
      const viewportHeight = theme.subtract(window.innerHeight, 30);
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.productRightHeight = productRight.querySelector(
        ".product__info-container"
      ).offsetHeight;
      const stickyHeight =
        viewportHeight > this.productRightHeight
          ? this.productRightHeight
          : viewportHeight;
      // 添加或移除sticky类
      if (scrollTop > stickyHeight) {
        productRight.classList.add("sticky");
        // 当product-right高度大于可视区域高度
        if (this.productRightHeight > viewportHeight) {
          productRight.style.maxHeight = `${viewportHeight}px`;
        }
        // 当product-right高度小于可视区域高度
        else {
          productRight.style.maxHeight = `${theme.add(
            this.productRightHeight,
            30
          )}px`;
        }
      } else {
        productRight.classList.remove("sticky");
        productRight.style.maxHeight = "";
      }
    },
    //
    handleScroll() {
      this.showViewImage = false;
      this.checkSticky();
    },
    // 获取区域列表
    async getAreaList() {
      const jsonString = localStorage.getItem("areaList");
      this.areaList = theme.inspectJson(jsonString);
      if (this.areaList?.length > 0) return;
      const url = `${this.areaUrl}`;
      const response = await fetchRequest(url, "GET");
      if (!response.error) {
        this.areaList = response.data;
        localStorage.setItem("areaList", JSON.stringify(this.areaList));
      }
    },
    // 处理输入框聚焦
    handleAreaInputFocus() {
      this.showAreaList = true;
    },
    // 处理输入框输入
    handleAreaInputChange(event) {
      this.areaFilterText = event.target.value;
      // 如果有输入内容，隐藏第一个区域项
      const firstAreaItem = document.querySelector(".first-area-item");
      if (firstAreaItem) {
        firstAreaItem.style.display = this.areaFilterText ? "none" : "";
      }
    },

    // 处理点击区域项
    handleAreaItemClick(item) {
      const inputEle = document.querySelector(".n-base-selection-input");
      const firstAreaItem = document.querySelector(".first-area-item");

      if (inputEle) {
        inputEle.value = "";
        this.areaFilterText = "";
      }

      if (firstAreaItem) {
        firstAreaItem.style.display = "";
      }
      this.selectArea = item;

      // 隐藏区域列表
      this.showAreaList = false;

      // 获取配送信息
      this.getDeliveryInfo(item.iso2_code);
    },

    // 处理点击外部区域
    handleClickOutside(event) {
      const areaContainer = document.querySelector(".desktop-area");
      const areaList = document.querySelector(".desktop-area-list");

      // 如果点击的不是区域容器或区域列表内的元素，则隐藏区域列表
      if (
        areaContainer &&
        areaList &&
        !areaContainer.contains(event.target) &&
        !areaList.contains(event.target)
      ) {
        this.showAreaList = false;
      }
    },

    // 获取配送信息（根据区域代码）
    async getDeliveryInfo(areaCode) {
      // 这里可以调用获取配送信息的API
      const response = await fetchRequest(`${this.deliveryUrl}`, "POST", {
        iso2: areaCode,
      });
      if (!response.error) {
        this.deliveryList = response.data;
        if (this.deliveryList.length > 0) {
          this.$nextTick(() => {
            this.deliverySwiper.update();
            this.deliverySwiper.slideTo(0);
          });
        } else {
          this.selectArea = this.areaList.find(
            (item) => item.iso2_code == "US"
          );
          this.getDeliveryInfo(this.selectArea.iso2_code);
        }
      }
    },
    prevSlide() {
      this.deliverySwiper.slidePrev();
    },
    nextSlide() {
      this.deliverySwiper.slideNext();
    },
    timestampToDateTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const days = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const dayOfWeek = date.getDay();
      const month = date.getMonth();
      const day = date.getDate();
      return `${days[dayOfWeek]},${months[month]} ${day}`;
    },
    addBorderNoneClass() {
      const multiVariantList = document.querySelector(
        ".variants-list.multi-variant"
      );
      if (multiVariantList) {
        const visibleItems = Array.from(
          multiVariantList.querySelectorAll(".variants-item")
        ).filter((item) => {
          return window.getComputedStyle(item).display !== "none";
        });
        if (visibleItems.length > 0) {
          const lastVisibleItem = visibleItems[visibleItems.length - 1];
          if (lastVisibleItem.classList.contains("border-none")) return;
          lastVisibleItem.classList.add("border-none");
        }
      }
    },
    handleViewImage(img, event) {
      this.viewImageSrc = img;
      this.showViewImage = true;
      // 使用 $nextTick 确保在 DOM 更新后获取元素位置
      this.$nextTick(() => {
        // 获取触发事件的元素
        const triggerElement = event.currentTarget;
        const triggerRect = triggerElement.getBoundingClientRect();
        // 获取预览图元素
        const viewImage = document.querySelector(".view-image");
        if (viewImage) {
          // 计算预览图的位置，使其左侧与触发元素对齐
          const viewImageWidth = viewImage.offsetWidth;
          const viewImageHeight = viewImage.offsetHeight;
          // 设置预览图的位置
          viewImage.style.top = `${Number(
            triggerRect.top + triggerRect.height / 2 - viewImageHeight / 2
          )}px`; // 稍微向上偏移以美观
          const userSelected = theme.getCookies("userSelected");
          // 尝试解析 cookie 值（假设是 JSON 格式）
          const userConfig = JSON.parse(userSelected);

          if (userConfig && userConfig?.language === "ar") {
            viewImage.style.left = `${triggerRect.right + 25}px`;
          } else {
            viewImage.style.left = `${
              triggerRect.left - viewImageWidth - 20
            }px`; // 放在触发元素的左侧，留出20px间距,箭头宽度
          }
        }
      });
    },
    openSizeGuide() {
      document.querySelector(".size-guide-popup")?.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }
  },
  template: `
    <div>
      <div class="flex" v-if="showFreeShipFlag">
        <div class="product-tab" :class="freeShipTab ? 'active': ''" @click="filterFreeShip">freeshipping</div>
        <div class="product-tab" :class="!freeShipTab ? 'active': ''" @click="filterNoFreeShip">non-freeshipping</div>
      </div>
      <div v-if="showVariantSelect" class="multi-variant">
        <div v-for="(value, key, index) in productData.options">
          <div class="attr-name flex align-items-center" :class="index==1 && productData.title.includes(' Ring') ? 'justify-space-between' : ''">
            <span class="title">{{ key}}</span> <span v-if="index==0">: <span class="text-active">{{ handleVariantName(option1) }}</span></span>
            <div v-if="index==1 && productData.title.includes(' Ring')" class="flex gap-5 align-items-center cursor-pointer" @click="openSizeGuide">
              <svg t="1758941415210" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13568" width="32" height="32"><path d="M832 358.4h-98.133333v174.933333h-55.466667V358.4h-98.133333v174.933333h-55.466667V358.4H426.666667v174.933333H371.2V358.4H273.066667v174.933333H217.6V358.4H51.2v320l917.333333 4.266667V362.666667h-89.6v174.933333h-55.466666l8.533333-179.2zM1024 302.933333v435.2l-1024 4.266667V307.2l1024-4.266667z" fill="#515151" p-id="13569"></path></svg>
              <span class="underline active-color" style="font-size: 16px;">Size Guide</span>
            </div>
          </div>
         
          <div class="flex attr-img-list" v-if="index==0">
            <div class="relative attr-img cursor-pointer" :class="variantIndex == index ? 'active' : ''" v-for="(option, index) in optionList" @click="selectOption(option, index)">
              <div class="main-image" @mouseenter="handleViewImage(option.img, $event)" @mouseleave="showViewImage=false">
                <img :src="handleImg(option.img, 100)" :alt="productData.title">
              </div>
              <div class="variant-count" v-if="option.count>0">{{ option.count }}</div>
            </div>
          </div>
          
          <div class="variants-list multi-variant" v-else>
            <div class="variants-item flex justify-space-between align-items-center" v-for="variant in productData.variants" v-show="filterVariantShow(variant)">
              <div class="variant-title line-clamp-4">{{ handleTitle(variant.title) }}</div>
              <div class="variant-price">
                <div>{{ theme.formatPrice(theme.convertCurrency(variant.price, "usdToSet")) }}</div>
                <div class="flex justify-content-center" v-if="freeShipTab || variant.freeShipping"><div class="free-ship-tag">free shipping</div></div>
              </div>
              <div class="flex justify-content-end">
                <div>
                  <div>
                    <quantity-input class="quantity quantity-allff" :class="btnDisabled && variant.quantity <= 0 ? 'quantity-active': ''" v-if="!isCustom">
                      <button name="minus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity <= 0 ? 'disabled' : ''"  @click="reduceQuantity(variant)">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                        </svg>
                      </button> 
                      <input type="number" name="quantity" v-model="variant.quantity" @change="changeQuantity(variant)"class="quantity__input"> 
                      <button name="plus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity >= variant.inventory_quantity ? 'disabled' : ''" @click="addQuantity(variant)">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>
                      </button>
                    </quantity-input>
                  </div>
                  <div class="sku center" v-if="productData.minBatch > 1">Min.Order is {{ productData.minBatch }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="variants-list relative single-variant" v-else>
        <div v-if="productData.title.includes(' Ring')" class="attr-name flex justify-space-between align-items-center">
          <span class="title"></span>
          <div class="flex gap-5 align-items-center cursor-pointer" @click="openSizeGuide">
            <svg t="1758941415210" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13568" width="32" height="32"><path d="M832 358.4h-98.133333v174.933333h-55.466667V358.4h-98.133333v174.933333h-55.466667V358.4H426.666667v174.933333H371.2V358.4H273.066667v174.933333H217.6V358.4H51.2v320l917.333333 4.266667V362.666667h-89.6v174.933333h-55.466666l8.533333-179.2zM1024 302.933333v435.2l-1024 4.266667V307.2l1024-4.266667z" fill="#515151" p-id="13569"></path></svg>
            <span class="underline active-color" style="font-size: 16px;">Size Guide</span>
          </div>
        </div>
        <div class="variants-item" v-for="(variant, index) in productData.variants" v-show="showMore || index < 4">
          <div class="relative variant-img">
            <div class="main-image cursor-pointer" @mouseenter="handleViewImage(variant.featureImage, $event)" @mouseleave="showViewImage=false">
              <img :src="handleImg(variant.featureImage, 500)" :alt="productData.title">
            </div>
          </div>
          <div class="center variant-title">
            <div>{{ handleVariantName(variant.title) }}</div>
            <div class="flex justify-content-center" v-if="freeShipTab || variant.freeShipping"><div class="free-ship-tag">free shipping</div></div>
          </div>
          <div class="variant-price notranslate">
            {{ theme.formatPrice(theme.convertCurrency(variant.price, "usdToSet")) }}
          </div>
          
          <div class="flex justify-content-end">
            <div>
              <div>
                <quantity-input class="quantity quantity-allff" :class="btnDisabled && variant.quantity <= 0 ? 'quantity-active': ''" v-if="!isCustom">
                  <button name="minus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity <= 0 ? 'disabled' : ''"  @click="reduceQuantity(variant)">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                    </svg>
                  </button> 
                  <input type="number" name="quantity" v-model="variant.quantity" @change="changeQuantity(variant)"class="quantity__input"> 
                  <button name="plus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity >= variant.inventory_quantity ? 'disabled' : ''" @click="addQuantity(variant)">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>
                  </button>
                </quantity-input>
              </div>
              <div class="sku center" v-if="productData.minBatch > 1">Min.Order is {{ productData.minBatch }}</div>
            </div>
          </div>
        </div>
        <div v-if="productData.variants?.length>4 && !showMore" class="variant-more">
          <div class="show-more cursor-pointer" @click="showMore = true">View More</div>
        </div>
      </div>
      <div class="desktop-buy-btn">
        <div class="flex align-items-baseline gap-5" v-if="!isCustom">
          <div>Total Cost: </div>
          <div class="price notranslate">{{ theme.formatPrice(totalPrice || 0) }}</div>
        </div>
        <div class="flex align-items-center gap-20">
          <div class="btn wishlist heratPop flex align-items-center justify-content-center cursor-pointer" @click="updateWish">
            <i class="at at-heart" v-if="productData.favorite"></i>
            <img class="no-wish" v-if="!productData.favorite" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png?v=93766581999082064381724318209" alt="">
          </div>
          <div style="flex: 1">
            <div class="text-active" v-if="btnDisabled">{{ addCartTips }}</div>
            <div v-if="isCustom" class="add-to-cart-btn cursor-pointer" @click="personalize">Personalize</div>
            <div v-else class="add-to-cart-btn cursor-pointer" @click="addToCart">Add to Cart</div>
          </div>
        </div>
      </div>
      <div class="delivery margin-top-10">
        <div class="coupon-delivery">
          <div class="delivery-title">
            <span>Delivery: </span>
            <div class="flex items-center coupon-delivery-title">
              <div class="desktop-area">
                <input class="n-base-selection-input" type="text" @focus="handleAreaInputFocus" @input="handleAreaInputChange">
                <div class="first-area-item">
                  <img :src="selectArea.logo" alt="" v-show="selectArea.logo">
                  <span class="area-name">{{ selectArea.area_name }}</span>
                </div>
                <span class="icon-caret">
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                  </svg>
                </span>
              </div>
              <div class="desktop-area-list" v-show="showAreaList">
                <ul>
                  <li class="area-item" v-for="item in filteredAreas" :key="item.iso2_code" @click="handleAreaItemClick(item)" :data-name="item.area_name" :data-src="item.logo" :data-code="item.iso2_code">
                    <img :src="item.logo" alt="">
                    <span class="area-name">[{{item.iso2_code}}] {{item.area_name}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="swiper-pagination" v-show="deliveryList?.length > 1"></div>
          <span class="icon-caret swiper-btn-l" v-show="deliveryList?.length > 1" @click="prevSlide">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
            </svg>
          </span>
          <span class="icon-caret swiper-btn-r" v-show="deliveryList?.length > 1" @click="nextSlide">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
            </svg>
          </span>
        </div>

        <div class="info-box">
          <div class="swiper-container-delivery">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in deliveryList" :key="item.id">
                <div class="info-item">
                  <div class="title">{{item.shipping_name}}</div>
                  <div class="description">
                    <span>Expected to ship on</span>
                    <span class="time">
                      {{timestampToDateTime(
                        item.shipping_start_time
                      )}}-{{timestampToDateTime(item.shipping_end_time)}}
                    </span>
                  </div>
                  <div class="description">
                    <span>Estimated to be delivered on</span>
                    <span class="time">
                      {{timestampToDateTime(
                        item.delivered_start_time
                      )}}-{{timestampToDateTime(item.delivered_end_time)}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-image" v-show="showViewImage">
        <div class="arrow-right">
          <div class="shadow-arrow-right"></div>
        </div>
        <div class="main-image">
          <img :src="handleImg(viewImageSrc, 500)" :alt="productData.title">
        </div>
      </div>
    </div>`,
});

new Vue({
  el: "#variant-content",
});

document
  .querySelector(".size-guide-popup #ModalClose")
  ?.addEventListener("click", () => {
    document.querySelector(".size-guide-popup")?.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  });